// @ts-nocheck
export default class OsmAttributionControl {
  constructor() {
    this._container = document.createElement('div');

    this._container.style.backgroundColor = 'rgba(245, 245, 245, 0.7)';
    this._container.style.display = 'none';

    this._content = document.createElement('p');
    this._content.style.fontSize = '10px';
    this._content.style.margin = '0';
    this._content.style.padding = '2px 6px';
    this._content.innerHTML = '&copy <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors';
    this._container.appendChild(this._content);
  }

  get element() {
    return this._container;
  }

  show() {
    this._container.style.display = 'block';
  }

  hide() {
    this._container.style.display = 'none';
  }
}
